<template>
  <v-container>
    <v-row class="banner-container">
      <v-col cols="12">
        <a :href="href" class="d-none justify-center d-sm-flex" target="_blank">
          <v-img :src="banner" />
        </a>
      </v-col>
      <v-col cols="12">
        <a :href="href" class="d-flex d-sm-none" target="_blank">
          <v-img :src="square" />
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PartnerAd',
  data() {
    const images = {
      square: [
        require('@/assets/images/ads/KOBhappylySquare4.jpg'),
        require('@/assets/images/ads/KOBhappylySquare3.jpg'),
        require('@/assets/images/ads/KOBhappylySquare2.jpg'),
        require('@/assets/images/ads/KOBhappylySquare1.jpg'),
      ],
      banner: [
        require('@/assets/images/ads/KOBhappylyBanner4.jpg'),
        require('@/assets/images/ads/KOBhappylyBanner3.jpg'),
        require('@/assets/images/ads/KOBhappylyBanner2.jpg'),
        require('@/assets/images/ads/KOBhappylyBanner1.jpg'),
      ],
    }
    return {
      banner: images.banner[Math.floor(Math.random() * images.banner.length)],
      square: images.square[Math.floor(Math.random() * images.square.length)],
      href: 'https://www.discobedshop.com/',
    }
  },
}
</script>
<style>
.banner-container {
  background-color: #eeeeee;
}
</style>
